import { render, staticRenderFns } from "./DeliveryAddressConfirmModal.vue?vue&type=template&id=61a79b63&scoped=true&"
import script from "./DeliveryAddressConfirmModal.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddressConfirmModal.vue?vue&type=style&index=0&id=61a79b63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a79b63",
  null
  
)

export default component.exports